import { BASE_PURCHASE_ORDER_FLOW_PATH } from '../paths';

export const BASE_COVID_ORDER_FLOW_PATH = `${BASE_PURCHASE_ORDER_FLOW_PATH}/covid`;
